import mod from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bot.spinner.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bot.spinner.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/components/bot/spinner/bot.spinner.vue?vue&type=script&lang=js&
// module id = 716
// module chunks = 0 1 2 3 4 5 6 7 8 11